import { render, staticRenderFns } from "./channelAudit.vue?vue&type=template&id=72fe12c8&scoped=true&"
import script from "./channelAudit.vue?vue&type=script&lang=js&"
export * from "./channelAudit.vue?vue&type=script&lang=js&"
import style0 from "./channelAudit.vue?vue&type=style&index=0&id=72fe12c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fe12c8",
  null
  
)

export default component.exports